<template>
  <LuxyglobalFooter v-bind="$attrs">
    <template #logo>
      <div class="footer-content">
        <div class="company-block">
          <img
            class="logo-image"
            src="https://uploads.ytripos.com/uploaded/Fs1VKC7qso-1--wL99x4Ll6I9AIQ/luxyglobal-logo.png"
            alt="Luxy Global Tour logo"
          />
          <div class="contact-message">
            <div class="company">
              {{ safeT("shell.luxyglobalFooter.company") }}
            </div>
            <div class="address">
              {{ safeT("shell.luxyglobalFooter.address") }}
            </div>
            <div class="contact-type">
              <span class="telephone">{{
                safeT("shell.luxyglobalFooter.telephone")
              }}</span>
              <span class="email">{{
                safeT("shell.luxyglobalFooter.email", {
                  email: "info@luxyglobal.my"
                })
              }}</span>
            </div>
          </div>
        </div>
        <div class="contact-panel">
          <div class="contact-title">
            {{ safeT("shell.luxyglobalFooter.contact") }}
          </div>
          <div class="contact-list-content">
            <a
              v-for="(item, index) in linkList"
              :key="index"
              class="contact-list-item"
              :href="item.url"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="item.label"
            >
              <img :src="item.img" :alt="item.label" />
            </a>
          </div>
          <div class="qr-block">
            <img
              class="qr-image"
              src="https://uploads.ytripos.com/uploaded/Fl_Y_G3rbm-2Qhbj1ahcub6gl21w/luxyglobal-whatsapp.png"
              alt="Luxy Global Tour WhatsApp QR code"
            />
            <div class="qr-text">
              {{ safeT("shell.luxyglobalFooter.qrText") }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <div class="footer-spacer" />
    </template>
    <template #bottom>
      <div class="footer-bottom">
        <div class="bottom-tips">
          <a class="text-tips" @click="handlePrivacyStatement">{{
            safeT("shared.auth.termsAndConditions")
          }}</a>
          <a class="text-tips" @click="handleTermsAndConditions">{{
            safeT("shared.auth.privacyStatement")
          }}</a>
        </div>
      </div>
    </template>
  </LuxyglobalFooter>
  <my-drawer
    v-model="showDrawer"
    :title="drawerTitle"
    :content="drawerContent"
  />
</template>

<script setup lang="ts" name="Footer">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import MyDrawer from "@/distributions/consumer/y/components/Drawer/index.vue";
import LuxyglobalFooter from "@/distributions/consumer/y/layout/components/Footer.vue";
import {
  getUserAgreement,
  getUserPrivacy
} from "@/distributions/consumer/y/shared/terms";

const showDrawer = ref(false);
const drawerTitle = ref("");
const drawerContent = ref("");
const { locale, t } = useI18n();

function safeT(key: string, params?: Record<string, string>) {
  try {
    return t(key, params);
  } catch (error) {
    console.error("[luxyglobal/Footer] i18n key failed", {
      locale: locale.value,
      key,
      params,
      error
    });
    return key;
  }
}

const linkList = ref([
  {
    url: "https://www.instagram.com/luxyglobal_tour?igsh=MTV0Z3dhZnExNXpsYw==",
    label: "Instagram",
    img: "https://uploads.ytripos.com/uploaded/FuutCtwc5vmnrMo4KZgx2I7oUQNL/icon-ins.png"
  },
  {
    url: "https://xhslink.com/m/5qVGF4LKPnu",
    label: "Xiaohongshu",
    img: "https://uploads.ytripos.com/uploaded/Fll8MoVvDONj1V4AilpDsR-gxttr/icon-xiaohongshu.png"
  }
]);

async function getUserPrivacyContent() {
  return getUserPrivacy();
}

async function getUserAgreementContent() {
  return getUserAgreement();
}

async function handlePrivacyStatement() {
  showDrawer.value = true;
  const res = await getUserPrivacyContent();

  drawerTitle.value = res.title;
  drawerContent.value = res.content;
}

async function handleTermsAndConditions() {
  showDrawer.value = true;
  const res = await getUserAgreementContent();

  drawerTitle.value = res.title;
  drawerContent.value = res.content;
}
</script>

<style lang="scss" scoped>
.footer-content {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  gap: 64px;
}

.company-block {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
}

.logo-image {
  display: flex;
  width: 118px;
  height: 118px;
  margin-bottom: 18px;
  object-fit: contain;
}

.contact-message {
  max-width: 940px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 1.65;
  .company {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .address {
    max-width: 980px;
  }
  .contact-type {
    display: flex;
    flex-wrap: wrap;
    column-gap: 40px;
    row-gap: 8px;
    margin-top: 16px;
  }
}

.contact-panel {
  width: 380px;
  flex-shrink: 0;
}

.contact-title {
  margin-bottom: 18px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.8px;
}

.contact-list-content {
  display: flex;
  column-gap: 14px;
  margin-bottom: 28px;
}

.contact-list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  border-radius: 50%;
  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
  &:hover {
    border-color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.06);
    border-radius: 50%;
  }
}

.qr-block {
  display: flex;
  align-items: center;
  gap: 16px;
}

.qr-image {
  display: flex;
  width: 116px;
  height: 116px;
  object-fit: cover;
  flex-shrink: 0;
}

.qr-text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 1.7;
}

.footer-spacer {
  width: 100%;
  height: 1px;
}
.footer {
  background: #030303;
}
:deep() {
  .footer-main {
    display: block;
    width: 1080px;
    margin: 0 auto;
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }

  .footer-main > * + * {
    margin-top: 0;
  }
}

.footer-bottom {
  margin-top: 24px;
  .bottom-tips {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 68px;
  }
  .text-tips {
    text-decoration: underline;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    cursor: pointer;
  }
}

@media (max-width: 1024px) {
  .footer-content {
    flex-direction: column;
    gap: 40px;
  }

  .contact-panel {
    width: 100%;
  }

  .qr-block {
    align-items: flex-start;
  }
}

@media (max-width: 768px) {
  .contact-message {
    font-size: 13px;
    .company {
      font-size: 16px;
    }
    .contact-type {
      flex-direction: column;
    }
  }

  .qr-block {
    flex-direction: column;
  }

  .qr-text {
    max-width: 320px;
  }

  :deep() {
    .footer {
      padding-top: 28px;
      padding-bottom: 28px;
    }

    .footer-main {
      width: calc(100% - 32px);
      padding-bottom: 28px;
    }
  }

  .footer-bottom {
    .bottom-tips {
      column-gap: 28px;
      flex-wrap: wrap;
    }
    .text-tips {
      font-size: 13px;
    }
  }
}
</style>
